import React from 'react'

export const SidebarMenu: React.FC = (props) => {
  return <>{props.children}</>
}
